import React, { useState, useEffect } from "react";
import "./Header.css";

/* ================= SVG ICONS ================= */
const MenuToggleIcon = ({ isOpen }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ffffff"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {isOpen ? (
      <>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </>
    ) : (
      <>
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </>
    )}
  </svg>
);

/* ================= COMPONENT ================= */
function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => setMobileMenuOpen((prev) => !prev);
  const closeMenu = () => setMobileMenuOpen(false);

  /* ---------- Link Data ---------- */
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/AboutUs" },
    { name: "Programs", path: "/Programs" },
    { name: "Volunteer", path: "/Volunteer" },
    { name: "Beneficiaries", path: "/Beneficiaries" },
    { name: "Gallery", path: "/Gallery" },
    { name: "Contact", path: "/ContactUs" },
  ];

  /* ---------- Effects ---------- */
  // Close menus on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setMobileMenuOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  // Auto-close mobile menu on desktop resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) setMobileMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="premium-electric-header">
      <div className="navbar-container">
        {/* ================= LOGO ================= */}
        <a href="/" onClick={closeMenu} className="brand-logo-anchor">
          <img
            src="images/blogo.png"
            alt="Anuk Trust Logo"
            className="brand-logo-image"
          />
          <div className="brand-logo-text">
            <span className="logo-title">Anuk Charitable Trust</span>
            <span className="logo-subtitle">& Old Age Home</span>
          </div>
        </a>

        {/* ================= DESKTOP NAVIGATION ================= */}
        <nav className="desktop-navigation-menu">
          <ul className="nav-link-list">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a href={link.path} className="nav-item-link">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* ================= DESKTOP CTA ================= */}
        <div className="desktop-action-wrapper">
          <a href="/DonateNow" className="btn-white-solid">
            Donate Now
          </a>
        </div>

        {/* ================= MOBILE TOGGLE ================= */}
        <button
          className="mobile-hamburger-btn"
          onClick={toggleMenu}
          aria-label="Toggle navigation drawer"
          aria-expanded={mobileMenuOpen}
        >
          <MenuToggleIcon isOpen={mobileMenuOpen} />
        </button>
      </div>

      {/* ================= MOBILE DRAWER ================= */}
      <div
        className={`mobile-navigation-drawer ${
          mobileMenuOpen ? "drawer-active" : ""
        }`}
      >
        <nav className="mobile-nav-frame">
          <ul className="mobile-link-list">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a
                  href={link.path}
                  className="mobile-item-link"
                  onClick={closeMenu}
                >
                  {link.name}
                </a>
              </li>
            ))}

            <li className="mobile-cta-item">
              <a
                href="/DonateNow"
                className="btn-white-solid mobile-full-width"
                onClick={closeMenu}
              >
                Donate Now
              </a>
            </li>
          </ul>
        </nav>
      </div>

      {/* ================= BACKDROP ================= */}
      {mobileMenuOpen && (
        <div className="mobile-drawer-mask" onClick={closeMenu} />
      )}
    </header>
  );
}

export default Header;